import { render } from "./FormPositionTrainingTable.vue?vue&type=template&id=c85c4b02&scoped=true&ts=true"
import script from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"
export * from "./FormPositionTrainingTable.vue?vue&type=script&lang=ts"

import "./FormPositionTrainingTable.vue?vue&type=style&index=0&id=c85c4b02&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c85c4b02"]])

export default __exports__